module.exports = __webpack_public_path__ + "img/horizontal_6_7_5012.93b442ae.png";